module.exports = __webpack_public_path__ + "img/startConfigurationColliers@2x.0162563.webp";